import CookiesSnackbar from './CookiesSnackbar'

export default CookiesSnackbar
